import FormConfig from "./formConfig.js";
import { fun_PostAction, fun_UploadImg, fun_Download } from "@/api/index";
import { fun_DownloadFile } from "@/utils/validate";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      // 全局加载
      fullLoading: false,
      // 列表loading状态
      loading: false,
      // 操作类型
      controllerFlg: null, // 操作标志
      // 主键
      id: null, // 主键
      // 勾选的数据
      multipleSelection: [],
      // 表格基础数据
      tableColumns: [
        {
          label: "注册类型",
          prop: "tradeRequirements",
        },
        {
          label: "注册等级（含及以上）",
          prop: "tradeLevel",
        },
        {
          label: "注册专业",
          prop: "regTradeTypeNum",
        },
        {
          label: "要求说明",
          prop: "requirements",
        },
      ],
      // 表单绑定数据
      formObj: {
        // 表格数据
        tableData: [],
      },
      // 列表绑定验证规则
      rules: {
        tradeRequirements: [
          {
            required: true,
            message: "该输入项为必输项",
            trigger: "blur"
          },
        ],
        tradeLevel: [
          {
            required: true,
            message: "该输入项为必输项",
            trigger: "blur"
          },
        ],
        regTradeTypeNum: [
          {
            required: true,
            message: "该输入项为必输项",
            trigger: "blur"
          },
        ],
        requirements: [
          {
            required: true,
            message: "该输入项为必输项",
            trigger: "blur"
          },
        ],
      },
      // 表单错误
      errRules: {

      },
      // 表头按钮
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "circle-plus-outline"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 表单对象
      form: {

      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 注册等级
      tradeLevelOptions: [],
      // 注册专业
      regTradeTypeNumOptions: [],
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    /**
     * 打开时调用
     */
    fun_Open(){
      // 如果是详情
      if (this.controllerFlg === 'detail') {
        // 清空表头
        this.btnList = [];
      }
      // 获取一览表单
      this.fun_GetList();
    },
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        fun_PostAction("/tenderRegistration/tendererProjectManagerList", {
          registrationId: this.id,
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 判断请求是否成功
          if (result) {
            // 关闭loading
            this.loading = false;
            // 回显table
            this.formObj.tableData = data;
            // 遍历
            this.formObj.tableData.map((value, index) => {
              // 注册类型下拉框赋值
              this.fun_SetTradeRequirements(value.tradeRequirements, index);
            })
          } else {
            // 关闭loading
            this.loading = false;
            // 提示请求失败消息
            this.$message.error(msg);
          }
        });
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 调用添加方法
          var newValue = {
            tradeRequirements: null,
            tradeLevel: null,
            regTradeTypeNum: null,
            requirements: null,
          };
          //添加新的行数
          this.formObj.tableData.push(newValue);
          break;
        default:
          // 判断是否勾选
          if(this.multipleSelection.length <= 0){
            // 提示信息
            this.$alert("最少选择一条数据！", "warning");
            return;
          }
          // 弹出询问confirm
          this.$confirm("是否确定删除选中数据?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 遍历
            this.multipleSelection.map((value, index) => {
              // 遍历
              this.formObj.tableData.map((v, i) => {
                // 匹配已选中的
                if (value.index === v.index) {
                  // 删除勾选的数据
                  this.formObj.tableData.splice(i, 1);
                }
              });
            });
            // 清除选中数据
            this.$refs.multipleTable.clearSelection();
          });
      }
    },
    /**
     * 列表添加class
     */
    addClass(row, column, rowIndex, columnIndex) {
      // 判断是序号
      if (row.column.type === "index") {
        return "index"
      }
    },
    /**
     * 添加时执行的方法
     * @author shuhua
     */
    tableRowClassName(row, rowIndex) {
      // 给每一行新增一个下标
      row.row.index = row.rowIndex;
    },
    /**
     * 列表勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 赋值勾选数组
      this.multipleSelection = e;
    },
    /**
     * 下拉框赋值
     */
    fun_SetTradeRequirements(e, i) {
      // 注册等级下拉框
      this.fun_TradeLevelCombobox(e, i);
      // 注册专业下拉框
      this.fun_RegTradeTypeNumCombobox(e, i);
    },
    /**
     * 注册类型下拉框
     */
    fun_ChangeTradeRequirements(e, i) {
      // 赋值注册类型
      this.formObj.tableData[i].tradeRequirements = e;
      // 清空注册等级
      this.formObj.tableData[i].tradeLevel = '';
      // 清空注册专业
      this.formObj.tableData[i].regTradeTypeNum = '';
      // 注册等级下拉框
      this.fun_TradeLevelCombobox(e, i);
      // 注册专业下拉框
      this.fun_RegTradeTypeNumCombobox(e, i);
    },
    /**
     * 注册等级下拉框
     */
    fun_TradeLevelCombobox(e, i) {
      // 获取value值
      e = e.substring(e.indexOf('|') + 1, e.length);
      // 发起请求
      fun_PostAction("/regTradeLevel/RegTradeLevelCombobox", {
        tradeType: e,
      }).then(res => {
        // 解构res.data
        const { result, data, msg} = res.data;
        // 操作成功
        if (result) {
          // 注册等级下拉框数据
          this.tradeLevelOptions.splice(i, 1, data);
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 注册专业下拉框
     */
    fun_RegTradeTypeNumCombobox(e, i) {
      // 获取value值
      e = e.substring(e.indexOf('|') + 1, e.length);
      // 发起请求
      fun_PostAction("/regTradeType/RegTradeTypeCombobox", {
        tradeType: e,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 注册专业下拉框数据
          this.regTradeTypeNumOptions.splice(i, 1, data);
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
  }
};
